// extracted by mini-css-extract-plugin
module.exports = {"modal":"LoginModal_modal__33OqR","section":"LoginModal_section__3hN7C","close":"LoginModal_close__Fhut9"};